"use client";

import { Quote } from "lucide-react";

type Testimonial = {
  comment: string;
  author: string;
};

const initials = (name: string) =>
  name
    .split(" ")
    .map((part) => part[0])
    .slice(0, 2)
    .join("");

const Testimonials = ({ testimonials }: { testimonials: Testimonial[] }) => {
  return (
    <section className="bg-[#FFFFFF] px-5 py-20 sm:px-8 md:py-28 lg:px-10">
      <div className="mx-auto max-w-7xl">
        <div className="mb-10 grid gap-6 md:grid-cols-[1fr_.65fr] md:items-end">
          <div>
            <p className="mb-4 text-xs font-extrabold tracking-[0.14em] text-[#0369A1] uppercase">
              Customer feedback
            </p>
            <h2 className="max-w-3xl text-4xl leading-tight font-extrabold tracking-[-0.035em] text-[#0F172A] sm:text-5xl">
              Peace of mind, in their words.
            </h2>
          </div>
          <p className="max-w-lg leading-7 text-[#475569] md:ml-auto">
            Homeowners across Bengaluru choose Servani for quick responses,
            dependable materials, and installation that looks clean.
          </p>
        </div>

        <div className="no-scrollbar -mx-5 flex snap-x snap-mandatory gap-5 overflow-x-auto px-5 pb-5 sm:-mx-8 sm:px-8 lg:-mx-0 lg:px-0">
          {testimonials.map((testimonial) => (
            <article
              key={`${testimonial.author}-${testimonial.comment}`}
              className="flex min-h-[285px] min-w-[84vw] snap-start flex-col rounded-[1.5rem] border border-[#0F172A]/10 bg-[#F0F9FF] p-6 sm:min-w-[360px] sm:p-7"
            >
              <Quote className="size-8 text-[#0369A1]" fill="currentColor" strokeWidth={0} />
              <p className="mt-5 flex-1 text-base leading-7 font-medium text-[#334155]">
                “{testimonial.comment}”
              </p>
              <div className="mt-6 flex items-center gap-3 border-t border-[#0F172A]/10 pt-5">
                <div className="grid size-11 place-items-center rounded-full bg-[#0C4A6E] text-xs font-extrabold text-white">
                  {initials(testimonial.author)}
                </div>
                <div>
                  <p className="text-sm font-extrabold text-[#0F172A]">{testimonial.author}</p>
                  <p className="mt-0.5 text-xs text-[#475569]">Customer comment</p>
                </div>
              </div>
            </article>
          ))}
        </div>

        <p className="mt-3 text-center text-xs font-semibold tracking-wide text-[#64748B]">
          Swipe to read all {testimonials.length} reviews →
        </p>
      </div>
    </section>
  );
};

export default Testimonials;
